import { SecondaryButton } from '@systemeio/ui'
import { useStore } from 'modules/stores/store/hooks/use-store'
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query'
import { FC } from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUserDomains from 'shared/hooks/use-user-domains'
import { OpenInNewIcon } from '@systemeio/ui/icons'

const StoreViewButton: FC = () => {
  const { t } = useLocoTranslation()

  const { storeId } = useStoreQuery()

  const { data: storeView } = useStore(storeId)

  const { userDomains } = useUserDomains()

  const domain = userDomains?.find(domain => domain.id === storeView?.domainId)

  const url =
    domain && storeView
      ? `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${domain.name}/${storeView.path}`
      : ''

  return (
    <SecondaryButton
      as={LinkWithoutPrefetch}
      target={'_blank'}
      rel={'noreferrer'}
      href={url}
      aria-disabled={!url}
    >
      <OpenInNewIcon
        className={'fill-text-primary group-hover:fill-background-secondary main-transition-colors'}
      />
      <span className="hidden sm:inline">{t('global.view')}</span>
    </SecondaryButton>
  )
}

export default StoreViewButton
